import React from 'react';
import { IBookmarkGroupState } from 'components/domain/fdr-bookmark/fdr-bookmark-types';
import useBookmarkGroupData from 'components/domain/fdr-bookmark/hooks/useBookmarkGroupData';
import FdrShareSiteTool from './fdr-share-site-tool';

interface IBookmarkShareTool {
  activeBookmarkGroup: IBookmarkGroupState;
}

const FdrBookmarkGroupShareTool: React.FC<IBookmarkShareTool> = ({
  activeBookmarkGroup,
}) => {
  const { image, shareUrl } = useBookmarkGroupData(activeBookmarkGroup.id);

  if (!shareUrl) {
    return null;
  }

  return (
    <FdrShareSiteTool
      pageTitle={activeBookmarkGroup.name}
      image={image}
      url={shareUrl}
      className={'bookmark-site-tools-button-wrapper'}
    />
  );
};
export default FdrBookmarkGroupShareTool;
